import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import Table from "../ui/Table";
import VirtualTable from "../ui/VirtualTable";
import { pubCall } from "../utils/PubSub";
import { showError, showMessage } from "../ui/Message";
import { GiftIcon, InfoIcon, SortIcon } from "../utils/Icons";
import { addISBNDashes, bm_date, drawPOSStatus, drawPrice, istl, kbdEvent, requestPrompt, showConfirm } from "../utils/Utils";
import customParseFormat from 'dayjs/plugin/customParseFormat';
import dayjs from "dayjs";
import Space from "../ui/Space";
import Card from "../ui/Card";
import Label from "../ui/Label";
import Divider from "../ui/Divider";
import Input from "../ui/Input";
import { useTabs } from "../hooks/useTabs";
import { KBD } from "../utils/Keybindings";
import { ROUTES } from "../utils/Routes";
import { listen } from "../hooks/Listener";
import { drawPicker } from "../popovers/Picker";
import { ENUMS } from "../utils/Enums";
import ISBNSearch from "./pos/ISBNSearch";
import { createModal } from "../hooks/createModal";
import Nav from "../ui/Nav";
import { apiCall } from "../utils/Api";
import { TRANSACTION_ITEM } from "../utils/Struct";
import { pos_addItem, pos_removeItem, pos_startNewTransaction, pos_editItem } from "../controllers/POSController";
import Cookies from "js-cookie";
import Status from "../ui/Status";
import PriceField from "../ui/PriceField";
import InventorySearch from "../popups/InventorySearch";
import { drawProductSearch } from "../controllers/GlobalController";
import POSChangeDiscounts from "./POSChangeDiscounts";
import POSChangeQuantities from "./POSChangeQuantities";
import POSChangeFB from "./POSChangeFB";
import POSChangeCustomerPO from "./POSChangeCustomerPO";
import POSGiftCard from "./POSGiftCard";
import POSNewGiftCard from "./POSNewGiftCard";
import { CopyIconInv, DeleteIcon, EditIconInv, IndexIcon, NewIcon, SettingsIcon, ViewIconInv, } from "../utils/Icons";
import IconNav from "../ui/IconNav";

export default function POSItems(props) {

    const { toggleView = () => { }, setSelectedItem = () => { } } = props;


    const NEW_ROW = { pos_id: "", __new: true };

    const {
        employee = "",
        controller = "",
        signal = {},
        loading = false,
        showTender = () => { },
        setLoading = () => { },
        header = {},
        setHeader = () => { },
        route = "",
        state = {},
        setState = () => { },
        cancelEdit = () => { },
    } = props;

    const row_key = "pos_id"
    const buffer = 20;
    const [data, setData] = useState([]);
    const [align, setAlign] = useState("auto")
    const skip_invoice_check = useRef(false);
    const returnToPrimaryCodeRef = useRef(false);
    const skipNextItemsFetch = useRef(false);
    const focusPrimaryCode = () => {
        setIndex("primary_code");

        requestAnimationFrame(() => {
            refs.current?.primary_code?.focus?.();
            refs.current?.primary_code?.select?.();
        });
    };

    const [filters, setFilters] = useState({
        sort: "id"
    })





    useEffect(() => {
        if (state.view === "items") {
            focusField();
        }
    }, [props.focus])



    // data with new row added. 
    const tableData = state.edit
        ? [...data, NEW_ROW]
        : data;

    const isNewRow = (row) => row?.__new === true || row?.pos_id === "";

    const [selected, setSelected] = useState({})
    const lastCustPoRef = useRef(header?.purchase_order || "");


    const getStock = (_stock) => {
        if (_stock?.stc_id) {
            pubCall("stock.getSingleExtras", { stock_id: _stock.stc_id }, (_s, _r) => {
                if (_s) {
                    setSelectedItem({ stock_data: _r.stock, in_stock: true, switchEdit: props.closeEdit })
                }
            })
        } else {
            setSelectedItem({ stock_data: selected, in_stock: true, switchEdit: props.closeEdit })
        }
    }



    useEffect(() => {

        getStock(selected);

    }, [selected])

    const blurField = (_field = index) => {
        const el = refs.current[_field];
        if (el && typeof el.blur === 'function') {
            el.blur();
        }
    }

    const focusField = (_field = index) => {
        const el = refs.current[_field];
        if (el && typeof el.focus === 'function') {
            el.focus();
        }
    }


    const fetchItems = () => {

        if (skipNextItemsFetch.current) {
            skipNextItemsFetch.current = false;
            return;
        }
        // pos_id - for remembering...
        if (state.view !== "items") return;


        if (!header?.invoice) {
            setData([])
            return;
        }

        setLoading(true);
        pubCall("point_of_sale.getInitialItem", { sort: filters.sort, invoice: header?.invoice, limit: 40 }, (_s, _r) => {
            if (_s) {
                setData(_r.rows_next);
                setSelected((_r.rows_next.length > 0) ? _r.rows_next[0] : {})

            }
            setLoading(false)
        })
    }

    useEffect(fetchItems, [state.view, header?.posh_id, filters.sort]);


    const showSearch = () => {
        drawProductSearch({
            controller: controller, return_search: true, callback: (_obj) => {

                if (_obj) {
                    if (_obj?.title_link) {
                        addItem({ primary_code: _obj.title_link.primary_code, condition_code: " " }, true)
                    } else {
                        addItem({ primary_code: _obj.primary_code, condition_code: _obj.condition_code }, true)
                    }
                } else {
                    focusField();
                }
                requestAnimationFrame(() => {
                    window.bm_state.value = route;
                });
            }
        })
    }


    const changeTax = (f) => {

        if (!f?.pos_id) { return; }

        let _obj = {
            pos_id: f?.pos_id,
            invoice: header?.invoice,
            sort: filters.sort,
            limit: 40,
            clerk_code: employee,
            to_tax_code: String(f?.tax_code)
        }

        blurField();
        setLoading(true)
        pubCall("point_of_sale.setTaxCodeOnAllItems", _obj, (_s, _r) => {
            if (_s) {
                if (_r?.rows_next) {
                    const rows = _r.rows_previous.concat(_r.rows_next);
                    const currentId = state?.editing || selected?.[row_key];
                    const updatedSelected = rows.find(row => row?.[row_key] === currentId);

                    setData(rows);
                    setHeader(_r.header);
                    if (updatedSelected) {
                        setSelected(updatedSelected);
                        if (state?.editing === updatedSelected?.[row_key]) {
                            setTabs(makeEditTabsFromRow(updatedSelected));
                        }
                    } else {
                        setTabs(makeDefaultTabs());
                        setIndex("tax_code");
                        setState(s => ({
                            ...s,
                            edit: true,
                            adding: false,
                            editing: null,
                            show_pos_card: true,
                        }));
                        setSelected(rows[0] || {});
                    }
                }

            } else {
                showError(_r);
            }
            setLoading(false)
            focusField();
        });


    }



    const changeQuantities = (f) => {

        if (!f?.pos_id) { return; }

        const _route = window.bm_state.value;
        window.bm_state.value = ROUTES.POS.CHANGE_QUANTITIES;
        blurField();

        createModal({
            component: <POSChangeQuantities
                employee={employee}
                pos_id={f?.pos_id}
                sort={filters.sort}
                invoice={header?.invoice}
                controller={controller}
                route={ROUTES.POS.CHANGE_QUANTITIES} />,
            closable: true,
            title: "Change Quantities",
            callback: (_r) => {
                if (_r?.rows_next) {
                    const rows = _r.rows_previous.concat(_r.rows_next);
                    const currentId = state?.editing || selected?.[row_key];
                    const updatedSelected = rows.find(row => row?.[row_key] === currentId);

                    setData(rows);
                    setHeader(_r.header);
                    if (updatedSelected) {
                        setSelected(updatedSelected);
                        if (state?.editing === updatedSelected?.[row_key]) {
                            setTabs(makeEditTabsFromRow(updatedSelected));
                        }
                    } else {
                        setTabs(makeDefaultTabs());
                        setIndex("primary_code");
                        setState(s => ({
                            ...s,
                            edit: true,
                            adding: false,
                            editing: null,
                            show_pos_card: true,
                        }));
                        setSelected(rows[0] || {});
                    }
                }
                focusField();
                window.bm_state.value = _route;
            }
        })
    }


    const changeCustPO = (f) => {

        if (!f?.pos_id) { return; }

        const _route = window.bm_state.value;
        window.bm_state.value = ROUTES.POS.CHANGE_QUANTITIES;
        blurField();

        createModal({
            component: <POSChangeCustomerPO
                employee={employee}
                pos_id={f?.pos_id}
                cust_po={f?.cust_po}
                sort={filters.sort}
                invoice={header?.invoice}
                controller={controller}
                route={ROUTES.POS.CHANGE_QUANTITIES} />,
            closable: true,
            title: "Change Customer PO",
            callback: (_r) => {
                if (_r?.rows_next) {
                    const rows = _r.rows_previous.concat(_r.rows_next);
                    const currentId = state?.editing || selected?.[row_key];
                    const updatedSelected = rows.find(row => row?.[row_key] === currentId);

                    setData(rows);
                    setHeader(_r.header);
                    if (updatedSelected) {
                        setSelected(updatedSelected);
                        if (state?.editing === updatedSelected?.[row_key]) {
                            setTabs(makeEditTabsFromRow(updatedSelected));
                        }
                    } else {
                        setTabs(makeDefaultTabs());
                        setIndex("primary_code");
                        setState(s => ({
                            ...s,
                            edit: true,
                            adding: false,
                            editing: null,
                            show_pos_card: true,
                        }));
                        setSelected(rows[0] || {});
                    }
                }
                focusField();
                window.bm_state.value = _route;
            }
        })
    }


    const changeFB = (f) => {

        if (!f?.pos_id) { return; }

        const _route = window.bm_state.value;
        window.bm_state.value = ROUTES.POS.CHANGE_FB;
        blurField();

        createModal({
            component: <POSChangeFB
                employee={employee}
                pos_id={f?.pos_id}
                sort={filters.sort}
                invoice={header?.invoice}
                controller={controller}
                route={ROUTES.POS.CHANGE_FB} />,
            closable: true,
            title: "Change FB Reward",
            callback: (_r) => {
                if (_r?.rows_next) {
                    const rows = _r.rows_previous.concat(_r.rows_next);
                    const currentId = state?.editing || selected?.[row_key];
                    const updatedSelected = rows.find(row => row?.[row_key] === currentId);

                    setData(rows);
                    setHeader(_r.header);
                    if (updatedSelected) {
                        setSelected(updatedSelected);
                        if (state?.editing === updatedSelected?.[row_key]) {
                            setTabs(makeEditTabsFromRow(updatedSelected));
                        }
                    } else {
                        setTabs(makeDefaultTabs());
                        setIndex("points");
                        setState(s => ({
                            ...s,
                            edit: true,
                            adding: false,
                            editing: null,
                            show_pos_card: true,
                        }));
                        setSelected(rows[0] || {});
                    }
                }
                focusField();
                window.bm_state.value = _route;
            }
        })
    }



    const changeDiscounts = (f) => {

        if (!f?.pos_id) { return; }

        const _route = window.bm_state.value;
        window.bm_state.value = ROUTES.POS.CHANGE_DISCOUNTS;
        blurField();
        createModal({
            component: <POSChangeDiscounts
                from_discount={f.discount || ""}
                to_discount={header?.customer_ship_to?.discount || 0}
                employee={employee}
                sort={filters.sort}
                pos_id={f?.pos_id}
                invoice={header?.invoice}
                controller={controller}
                route={ROUTES.POS.CHANGE_DISCOUNTS} />,
            closable: true,
            title: "Change Discounts",
            callback: (_r) => {
                if (_r?.rows_next) {
                    const rows = _r.rows_previous.concat(_r.rows_next);
                    const currentId = state?.editing || selected?.[row_key];
                    const updatedSelected = rows.find(row => row?.[row_key] === currentId);
                    setData(rows);
                    setHeader(_r.header);
                    if (updatedSelected) {
                        setSelected(updatedSelected);
                        if (state?.editing === updatedSelected?.[row_key]) {
                            setTabs(makeEditTabsFromRow(updatedSelected));
                        }
                    } else {
                        setTabs(makeDefaultTabs());
                        setIndex("primary_code");
                        setState(s => ({
                            ...s,
                            edit: true,
                            adding: false,
                            editing: null,
                            show_pos_card: true,
                        }));
                        setSelected(rows[0] || {});
                    }
                }
                focusField();
                window.bm_state.value = _route;
            }
        })
    }


    const searchISBN = (_search) => {
        blurField();
        window.bm_state.value = ROUTES.POS.SEARCH_ISBN;

        createModal({
            component: <ISBNSearch
                callback_on_single_result
                controller={controller}
                search={_search}
                route={ROUTES.POS.SEARCH_ISBN}
            />,
            closable: true,
            title: "Select Item (Multiple Matches)",
            callback: (e) => {
                window.bm_state.value = ROUTES.POS.EDIT;

                if (e) {
                    returnToPrimaryCodeRef.current = false;
                    addItem(e, true);
                    return;
                }

                if (returnToPrimaryCodeRef.current) {
                    returnToPrimaryCodeRef.current = false;
                    focusPrimaryCode();
                    return;
                }

                focusField();
            }
        });
    };

    const addItemToInventory = (_item) => {
        props.addTitle(_item, (_stock) => {
            if (_stock) {
                addItem({ primary_code: _stock.primary_code, condition_code: _stock.condition_code })
            } else {


            }
        })

    }

    const resetNewItemRow = () => {
        setTabs(makeDefaultTabs());
        setIndex("primary_code");

        setState(s => ({
            ...s,
            edit: true,
            adding: true,
            editing: null,
            show_pos_card: true,
        }));

        setSelected(NEW_ROW);
    };


    const drawNewGiftCard = (_title) => {


        blurField();
        const return_route = window.bm_state.value;
        window.bm_state.value = ROUTES.POS.NEW_GIFT_CARD;

        createModal({
            component: <POSNewGiftCard
                callback_on_single_result
                controller={controller}
                giftcard={_title.primary_code}
                header={header}
                route={ROUTES.POS.NEW_GIFT_CARD}
            />,
            closable: true,
            title: "New Gift Card",
            callback: (e) => {
                window.bm_state.value = return_route;
                focusField();

                if (e) {



                    if (e.refill) {
                        addItem({ ..._title, price: e.refill, cust_po: e.note }, true, true)
                    } else {
                        addItem({ ..._title, price: -e.redeem }, true, true)
                    }
                }

            }
        });
    }

    const drawGiftCard = (_title) => {


        blurField();
        const return_route = window.bm_state.value;
        window.bm_state.value = ROUTES.POS.GIFT_CARD;

        createModal({
            component: <POSGiftCard
                callback_on_single_result
                controller={controller}
                giftcard={_title.primary_code}
                header={header}
                route={ROUTES.POS.GIFT_CARD}
            />,
            closable: true,
            title: "Gift Card",
            callback: (e) => {
                window.bm_state.value = return_route;
                focusField();

                if (e) {

                    console.log(e);

                    if (e.refill) {
                        update("cust_po", e.note);
                        requestAnimationFrame(() => {
                            addItem({ ..._title, price: e.refill, cust_po: e.note }, true, true)
                        })

                    } else {
                        addItem({ ..._title, price: -e.redeem }, true, true)
                    }
                }

            }
        });
    }


    const addItem = (_title, _force = false, skip_gc = false) => {



        if (_title?.primary_code.startsWith("GC") && !skip_gc) {

            if (_title?.primary_code === "GC") {
                drawNewGiftCard(_title);
            } else {
                drawGiftCard(_title);
            }


            return;

        }




        if (!_title?.primary_code) return;
        if (_title?.primary_code.length < 13 && !_force) {
            searchISBN(_title?.primary_code);
            return;
        }
        const custPo = getVal("cust_po") || "";
        lastCustPoRef.current = custPo;

        const item = {
            ...TRANSACTION_ITEM,
            cust_po: getVal("cust_po"),
            primary_code: _title?.primary_code,
            condition_code: _title?.condition_code || "",
            quantity: Number(getVal("quantity")) || 1,
            price: (skip_gc) ? _title.price : Number(getVal("price")) || 0,
            discount: Number(getVal("discount")) || 0,
        };

        if (!header?.invoice || skip_invoice_check?.current) {
            // does not exits, create


            pos_startNewTransaction({ header: header, item: item, check_onhands: !_force, employee: employee }, (_s, _r) => {

                if (_s) {
                    skipNextItemsFetch.current = true;
                    setHeader(_r.header);
                    Cookies.set("pos_id", _r?.posh_id);
                    props.fetch();
                    setData([_r.items_first[0]]);
                    props.addNewRow(_r.header)
                    resetNewItemRow();
                    skip_invoice_check.current = false;
                } else {

                    if (_r.error === "com.bmo.not_enough_onhands") {
                        showConfirm({
                            controller: controller,
                            route: route, title: "Warning", description: <div style={{ "textAlign": "center" }}>Qty sold is greater than the OnHand<br /><div className="shim" />Allow negative OH?<div className="shim" /><div className="shim" /></div>, callback: (_key) => {
                                if (_key) {
                                    addItem(_title, true)
                                } else {
                                    focusField();
                                }
                            }
                        })

                    }

                    else if (_r.error === "com.bmo.does_not_exist") {
                        // prompt to add to inventory... 
                        showConfirm({
                            controller: controller,
                            route: route, title: "Warning", description: <div style={{ "textAlign": "center" }}><strong>{item.primary_code}</strong> <br /> was not found. <br /><div className="shim" /> Add to inventory?</div>, callback: (_key) => {
                                if (_key) {
                                    addItemToInventory(item);
                                } else {
                                    focusField();
                                }
                            }
                        })
                    } else {
                        showError(_r);
                        focusField();
                    }
                }


            });
        } else {
            // add
            pos_addItem({ invoice: header.invoice, item: item, check_onhands: !_force, employee: employee }, (_s, _r) => {

                if (_s) {
                    setData(prev => [...prev, _r.item]);
                    setHeader(_r.header);
                    resetNewItemRow();

                } else {
                    if (_r.error === "com.bmo.not_enough_onhands") {
                        showConfirm({
                            controller: controller,
                            route: route, title: "Warning", description: <div style={{ "textAlign": "center" }}>Qty sold is greater than the OnHand<br /><div className="shim" />Allow negative OH?<div className="shim" /><div className="shim" /></div>, callback: (_key) => {
                                if (_key) {
                                    addItem(_title, true);
                                } else {
                                    focusField();
                                }
                            }
                        })

                    } else if (_r.error === "com.bmo.does_not_exist") {
                        // prompt to add to inventory... 
                        showConfirm({
                            controller: controller,
                            route: route, title: "Warning", description: <div style={{ "textAlign": "center" }}><strong>{item.primary_code}</strong> <br /> was not found. <br /><div className="shim" /> Add to inventory?</div>, callback: (_key) => {
                                if (_key) {
                                    addItemToInventory(item);
                                } else {
                                    focusField();
                                }
                            }
                        })
                    } else {
                        showError(_r);
                        focusField();
                    }

                }


            });
        }
    };

    const removeItem = () => {

        showConfirm({
            controller: controller,
            route: route,
            description: <div style={{ "textAlign": "center" }}>Delete row?</div>,
            title: "Warning",
            callback: (e) => {
                if (e) {
                    pos_removeItem({ point_of_sale_id: selected?.[row_key], employee: employee }, (_s, _r) => {
                        if (_s) {

                            const updated = data.filter(item => item[row_key] !== selected?.[row_key]);
                            const deleted = data.findIndex(row => row[row_key] === selected?.[row_key]);

                            // Don't delete the header, would like to re-use
                            if (updated?.length) {
                                console.log(_r.header)
                                setHeader(_r.header);
                            }
                            console.log(updated)
                            setData(updated);

                            if (!updated?.length) {
                                skip_invoice_check.current = true;
                                nextItem()
                            } else {
                                setSelected(updated[deleted - 1] || updated[0] || {});
                            }


                        } else {
                            showError(_r);
                        }
                    })
                }
            }
        })
    }

    const cancelRowEdit = () => {



        blurField(index);

        setTabs(makeDefaultTabs());
        setIndex("primary_code");

        setState(s => ({
            ...s,
            edit: true,
            adding: false,
            editing: null,
            show_pos_card: true,
        }));

        requestAnimationFrame(() => {
            // keep table row selected, but no field focused
            refs.current?.[index]?.blur?.();
        });
    };

    const makeEditTabsFromRow = (row) => [
        { label: "cust_po", key: "cust_po", value: row?.cust_po || "" },
        { label: "primary_code", key: "primary_code", value: row?.primary_code || "", skip: true },
        { label: "quantity", key: "quantity", value: row?.quantity ?? 1 },
        { label: "price", key: "price", value: row?.price ?? 0 },
        { label: "discount", key: "discount", value: row?.discount ?? 0 },
        { label: "tax_code", key: "tax_code", value: row?.tax_code || "" },
        { label: "points", key: "points", value: row?.points || "" },
    ];

    const editSelectedItemRow = () => {
        if (!selected?.[row_key]) return;

        setTabs(makeEditTabsFromRow(selected));

        setState(s => ({
            ...s,
            edit: true,
            adding: false,
            editing: selected[row_key],
            show_pos_card: true,
        }));

        setIndex("quantity");

        requestAnimationFrame(() => {
            refs.current?.quantity?.focus?.();
            refs.current?.quantity?.select?.();
        });
    };


    const saveEditedRow = (overrides = {}) => {
        if (!state?.editing || !selected?.[row_key]) return;

        blurField(index);

        const item = {
            ...selected,

            cust_po: overrides.cust_po ?? getCurrentVal("cust_po") ?? "",
            primary_code: selected.primary_code,
            quantity: Number(overrides.quantity ?? getCurrentVal("quantity")) || 0,
            price: Number(overrides.price ?? getCurrentVal("price")) || 0,
            discount: Number(overrides.discount ?? getCurrentVal("discount")) || 0,
            tax_code: overrides.tax_code ?? getCurrentVal("tax_code") ?? "",
            points: overrides.points ?? getCurrentVal("points") ?? "",
        };

        pos_editItem({ item, employee }, (_s, _r) => {
            if (_s) {
                const updatedItem = _r?.item || item;

                setData(prev =>
                    prev.map(row =>
                        row[row_key] === selected[row_key]
                            ? { ...row, ...updatedItem }
                            : row
                    )
                );

                setSelected(prev => ({ ...prev, ...updatedItem }));

                setTabs(makeDefaultTabs());
                setIndex("primary_code");

                setState(s => ({
                    ...s,
                    edit: true,
                    adding: false,
                    editing: null,
                    show_pos_card: true,
                }));

                showMessage("Row saved.");
            } else {
                showError(_r);

                requestAnimationFrame(() => {
                    refs.current?.[index]?.focus?.();
                });
            }
        });

    };

    const getCurrentTabs = () => {
        const currentKey = index;
        const currentEl = refs.current?.[currentKey];

        return tabs.map(tab => {
            if (tab.key !== currentKey) return tab;

            const liveValue =
                currentEl && "value" in currentEl
                    ? currentEl.value
                    : tab.value;

            return {
                ...tab,
                value: liveValue,
            };
        });
    };

    const getCurrentVal = (_key) => {
        const currentTabs = getCurrentTabs();
        return currentTabs.find(tab => tab.key === _key)?.value;
    };

    const canEditRow = (row) => {
        if (window.bm_state.value !== ROUTES.POS.EDIT) return false;
        if (!state?.edit) return false;

        // adding new row
        if (state?.adding && isNewRow(row)) {
            return true;
        }

        // editing existing row
        if (!state?.adding && state?.editing && row?.[row_key] === state.editing) {
            return true;
        }

        return false;
    };



    const makeDefaultTabs = () => [
        { label: "cust_po", key: "cust_po", value: lastCustPoRef.current || header?.purchase_order || "" },
        { label: "primary_code", key: "primary_code", value: "" },
        { label: "quantity", key: "quantity", value: 1 },
        { label: "price", key: "price", value: 0 },
        { label: "discount", key: "discount", value: header?.customer_ship_to?.discount || 0 },
        { label: "tax_code", key: "tax_code", value: "", skip: true },
        { label: "points", key: "points", value: "", skip: true },
    ];

    const {
        tabs, setTabs, index, setIndex, update, getVal, editProps, next, prev, refs
    } = useTabs(makeDefaultTabs(), "primary_code");

    useEffect(() => {
        if (!state.adding) { return; }
        update("discount", header?.customer_ship_to?.discount || 0);
    }, [header?.customer_ship_to?.discount, state.adding]);

    useLayoutEffect(() => {
        if (!state.edit || state.view !== "items") return;
        requestAnimationFrame(() => {
            const el = refs?.current[index];
            if (el) el.focus();
        });

    }, [index, state.edit]);



    useLayoutEffect(() => {

        if (!state.edit || !state.adding || state.view !== "items") return;

        if (index !== "primary_code") return;

        requestAnimationFrame(() => {

            refs.current?.primary_code?.focus?.();
            refs.current?.primary_code?.select?.();
        });
    }, [state.view, state.edit, state.adding, index, selected]);



    const switchToCustomer = () => {
        setState({ ...state, "view": "customer", show_pos_card: true, editing: null })
        window.bm_state.value = ROUTES.POS.CUSTOMER;
    }

    const switchToTransaction = () => {
        props.editTransaction();
    }

    const testIt = (item) => {
        requestPrompt({
            route: ROUTES.POS.POS, title: "Tobias Testing stuff..", inputProps: { style: { "textAlign": "left" } }, callback: (_s) => {
                let _itm = { ...item, "quantity": parseInt(_s) || 0 };
                pubCall("point_of_sale.editItem", { item: _itm }, (_s, _r) => {
                    if (_s) {
                        console.log(_r);
                    } else {
                        console.log(_r);
                        showError(_r);
                    }
                })
            }
        })
    }

    useEffect(() => {
        if (!state.edit) {
            if (skip_invoice_check?.current) {
                skip_invoice_check.current = false;
            }
            return;
        }

        const actions = (state.adding) ? pos_new_nav : (state.editing) ? pos_row_edit_nav : pos_edit_nav;

        const cleanup = listen(
            controller,
            ROUTES.POS.EDIT,
            actions,
            false,
            [KBD.ARROW_DOWN, KBD.ARROW_UP, KBD.ESCAPE, KBD.PAGE_DOWN]
        );

        return cleanup;
    }, [index, tabs, refs, state.adding, selected, data, state.edit, state.editing, state.show_pos_card]);


    useEffect(() => {
        if (!state?.adding) {
            return;
        }

        const primaryCode = getVal("primary_code");

        if (index !== "primary_code" && primaryCode) {
            returnToPrimaryCodeRef.current = true;

            requestAnimationFrame(() => {

                addItem({ primary_code: primaryCode, condition_code: "" });
            });


        }

    }, [index]);



    const columns = [
        {
            min: true, width: 50, key: "available_onhand", align: "right", title: <>aOH</>, render: (e) => {
                return (e) ? e : ""
            }
        },

        { min: true, width: 130, key: "class", align: "left", title: <>Class</> },
        { min: true, width: 100, grow: true, key: "title", align: "left", title: <>Title</> },
        {
            min: true, width: 123, key: "cust_po", align: "left", title: <>CustPo</>, render: (e, f) => {
                if (canEditRow(f)) {

                    return <><Input className="fill" uppercase maxLength={10} {...editProps("cust_po")} onF5={(e) => changeCustPO({ ...f, "cust_po": e })} onEnter={() => next()} edit={state.edit} width={110} /></>
                } else {
                    return e
                }
            }
        },
        {
            min: true, width: 163, key: "primary_code", align: "left", title: <>ISBN</>, render: (e, f) => {
                if (canEditRow(f) && !state.editing) {
                    return <>
                        <Input className="fill" {...editProps("primary_code")} onEnter={(_value, f) => {

                            if (state?.editing) {
                                next();
                                return;
                            }


                            if (_value === "") {
                                showTender(header)
                            } else {
                                addItem({ primary_code: _value, condition_code: "" })
                            }

                        }} onPageDown={(_value, f) => {
                            f.preventDefault();
                            f.stopPropagation();

                            if (state?.editing) {
                                saveEditedRow();
                                return;
                            }

                            if (_value === "") {
                                showTender(header)
                            } else {
                                addItem({ primary_code: _value, condition_code: "" })
                            }
                        }}

                            maxLength={13}
                            onFill={(_value) => {
                                ///addItem({ primary_code: _value, condition_code: "" })
                            }}
                            onPageUp={(e, f) => {
                                f.preventDefault();
                                f.stopPropagation();
                                showSearch()
                            }} edit={state.edit} width={150} />
                    </>
                } else {
                    return addISBNDashes(e, f.condition_code, false)
                }
            }
        },
        {
            min: true, width: 48, key: "quantity", align: "right", title: <>Qty</>, render: (e, f) => {
                if (canEditRow(f)) {
                    return <><Input className="fill" {...editProps("quantity")} onF5={(e) => changeQuantities({ ...f, "quantity": e })} number onEnter={() => next()} right onPageDown={() => setIndex("primary_code")} maxLength={3} edit={state.edit} width={35} /></>
                } else {
                    return e
                }
            }
        },
        {
            min: true, width: 85, key: "price", align: "right", title: <>Price</>, render: (e, f) => {

                let _class = ((f?.[row_key]) && (f.price_expected !== Number(e)));


                if (canEditRow(f)) {
                    return <><PriceField className={(_class) ? "fill error" : "fill"} {...editProps("price")} price onEnter={() => next()} onPageDown={(price) => {
                        update("price", price);
                        saveEditedRow({ price });
                    }} right edit={state.edit} width={72} /></>
                } else {

                    if (_class) {
                        return <><Input style={{ "fontWeight": "300" }} className={(_class) ? "fill error" : "fill"} value={drawPrice(e, true)} right number maxLength={2} edit={false} width={72} /></>
                    } else {
                        return drawPrice(e, true)
                    }

                }
            }
        },

        {
            min: true, width: 35, key: "discount", align: "right", title: <>%</>, render: (e, f) => {

                let _class = ((f?.[row_key]) && (f.discount_expected !== Number(e)));

                let customer_discount = header?.customer_ship_to?.discount || 0;
                let _green = (f.discount_expected && f.discount_expected > customer_discount);


                if (canEditRow(f)) {
                    return <><Input className={(_class) ? "fill error" : "fill"} {...editProps("discount")} right number onEnter={() => next()} onF5={(e) => changeDiscounts({ ...f, "discount": e })} maxLength={2} edit={state.edit} width={22} /></>
                } else {
                    if (_class) {
                        return <><Input style={{ "fontWeight": "300" }} className={(_class) ? "fill error" : "fill"} value={e} right number maxLength={2} edit={false} width={22} /></>
                    } else {
                        return <span style={{ "color": (_green) ? "var(--text-green)" : "inherit" }}>{e}</span>;
                    }

                }
            }
        },
        {
            min: true, width: 50, key: "tax_code", align: "right", title: <>Tax</>, render: (e, f) => {
                if (canEditRow(f) && state.editing) {
                    return <><Input className={"fill"} {...editProps("tax_code")} right uppercase chars={["1", "2", "B", "3"]} onEnter={() => next()} onF5={(e) => changeTax({ ...f, "tax_code": e })} maxLength={1} edit={state.edit} width={37} /></>
                } else {
                    return e
                }
            }
        },
        {
            min: true, width: 50, key: "points", align: "right", title: <>FB</>, render: (e, f) => {
                if (canEditRow(f) && state.editing) {
                    return <><Input className={"fill"} {...editProps("points")} onF5={(e) => changeFB({ ...f, "points": e })} right number onEnter={() => kbdEvent(KBD.PAGE_DOWN)} maxLength={2} edit={state.edit} width={37} /></>
                } else {
                    return e
                }
            }
        },
        // {
        //     min: true, width: 80, key: "total_price", align: "right", title: <>Total</>, render: (e) => {
        //         return (e) ? drawPrice(e, true) : ""
        //     }
        // },
        // { min: true, width: 90, key: "prepay_status", align: "left", title: <>PPY</> },
        {
            min: true, width: 90, key: "status", align: "left", title: <>Status</>, render: (e, f) => {
                return (e === "Prpy") ? f.prepay_status : e;
            }
        },
        {
            min: true, width: 80, key: "total_price", align: "right", title: <>Total</>, render: (e) => {
                return (e) ? drawPrice(e, true) : ""
            }
        },
    ];

    const fetchNext = (callback = () => { }) => {
        if (loading || data.length < 10) {
            callback([]);
            return;
        }

        setLoading(true);

        pubCall(
            "point_of_sale.getNextItem",
            {
                invoice: header?.invoice,
                limit: 20,
                pos_id: data[data.length - 1]?.[row_key],
                sort: filters.sort
            },
            (_s, _r) => {
                if (_s) {
                    const rows = Array.isArray(_r) ? _r : [];

                    if (rows.length > 0) {
                        setData(prev => [...prev, ...rows]);
                    }

                    callback(rows);
                } else {
                    showError(_r);
                    callback([]);
                }

                setLoading(false);
            }
        );
    };

    const fetchPrev = (callback = () => { }) => {
        if (loading || data.length < 40) {
            callback([]);
            return;
        }

        setLoading(true);

        pubCall(
            "point_of_sale.getPreviousItem",
            {
                invoice: header?.invoice,
                limit: 20,
                pos_id: data[0]?.[row_key],
                sort: filters.sort
            },
            (_s, _r) => {
                if (_s) {
                    const rows = Array.isArray(_r) ? _r : [];

                    if (rows.length > 0) {
                        setAlign("start");
                        setData(prev => [...rows, ...prev]);
                    }

                    callback(rows);
                } else {
                    showError(_r);
                    callback([]);
                }

                setLoading(false);
            }
        );
    };

    const nextItem = (_rows = 1) => {
        if (data.length === 0) {
            setSelected({});
            return;
        }

        setAlign("auto");

        const currentIndex = data.findIndex(
            item => item?.[row_key] === selected?.[row_key]
        );

        const nextIndex = currentIndex + _rows;
        const atBottom = nextIndex >= data.length;

        if (atBottom) {
            fetchNext((rows) => {
                if (rows.length > 0) {
                    setSelected(rows[0]);
                } else if (state.edit && _rows === 1) {
                    showNewRow();
                } else {
                    setSelected(data[data.length - 1]);
                }
            });

            return;
        }

        if (nextIndex > data.length - buffer && !loading) {
            fetchNext();
        }

        setSelected(data[nextIndex]);
    };

    const prevItem = (_rows = 1) => {
        if (data.length === 0) {
            setSelected({});
            return;
        }

        const currentIndex = data.findIndex(
            item => item?.[row_key] === selected?.[row_key]
        );

        const prevIndex = currentIndex - _rows;
        const atTop = prevIndex < 0;

        if (atTop) {
            fetchPrev((rows) => {
                if (rows.length > 0) {
                    setSelected(rows[rows.length - 1]);
                } else if (_rows === 1 && state.edit) {
                    switchToCustomer();
                } else {
                    setSelected(data[0]);
                }
            });

            return;
        }

        if (prevIndex < buffer && !loading) {
            fetchPrev();
        }

        setSelected(data[prevIndex]);
    };


    const statuses = {
        cust_po: "Customer's PO# or a notation",
        primary_code: "Enter or scan ISBN, ↑ ↓ to move, <PdDn> to tender, <PgUp> to look up",
        quantity: "Enter a quantity from -999 to 999, <F5> will repeat +/- (sell/return) mode",
        price: "Entering a price before the ISBN overides the ISBN's price",
        discount: "Enter discount. <F5> for options to change all discounts",
        tax_code: "Tax codes: 1 = Tax1, 2 = Tax2, B = Tax1&2, <F5> to repeat/change all ",
        points: "Cents per dollar this item earns (max 10). Blank to recalculate",
    }


    const pos_new_nav = [
        {
            key: KBD.ESCAPE,
            action: () => {
                cancelNewRow();
            }
        },

        {
            key: KBD.ARROW_DOWN, action: () => {

                if (getVal("primary_code") && index === "primary_code" && state.adding) {
                    returnToPrimaryCodeRef.current = true;
                    requestAnimationFrame(() => {
                        addItem({ primary_code: getVal("primary_code"), condition_code: "" });
                    });

                } else {
                    next()
                }

            }
        },
        {
            key: KBD.ARROW_UP,
            action: () => {


                if (index === "cust_po") {
                    if (data.length === 0 || selected?.[row_key] === data[data.length - 1]?.[row_key]) {
                        switchToCustomer();
                    } else {
                        setState(s => ({
                            ...s,
                            edit: true,
                            adding: false,
                            editing: null,
                        }));
                        setSelected(data[data.length - 1]);
                    }
                } else {
                    prev();
                }
            }
        },
    ];

    const cancelNewRow = () => {
        blurField(index);




        setTabs(makeDefaultTabs());
        setIndex("primary_code");

        if (data.length > 0) {
            setState(s => ({
                ...s,
                edit: true,
                adding: false,
                editing: null,
                show_pos_card: true,
            }));

            setSelected(data[data.length - 1]);
            return;
        }

        setState(s => ({
            ...s,
            edit: false,
            adding: false,
            editing: null,
            show_pos_card: true,
        }));

        if (!header?.invoice) {
            skip_invoice_check.current = false;
        }

        if (data.length === 0 && header?.invoice) {
            props.removeTransaction(header.invoice);
            window.bm_state.value = ROUTES.POS.POS;
            setState(s => ({
                ...s,
                edit: false,
                adding: false,
                view: "items"
            }));

            return;
        }



        cancelEdit(refs?.current?.[index], ROUTES.POS.EDIT);
    };

    const showNewRow = () => {

        setTabs(makeDefaultTabs());
        setIndex("primary_code");

        setState(s => ({
            ...s,
            edit: true,
            adding: true,
            editing: null,
            show_pos_card: true,
        }));

        setSelected(NEW_ROW);
    };


    const updateItemStatus = () => {
        drawPicker({
            controller: controller,
            value: selected?.status, title: "Status Codes", closeable: true, height: 300, route: route, callback: (e) => {
                if (e) {
                    const updated = { ...selected, "status": e };
                    pos_editItem({ item: updated, employee: employee }, (_s, _r) => {
                        if (_s) {
                            setSelected(_r.item);
                            setData(prev => prev.map(row => row[row_key] === selected[row_key] ? _r.item : row));
                        }
                    })

                }
            }, offset: [0, 10],
            options: ENUMS.POS_ITEM_STATUS
        })
    }


    useEffect(() => {
        if (state.view === "items" && state.adding) {
            setIndex("primary_code")
        }
    }, [state.view])

    const showSort = () => {

        drawPicker({
            controller: controller,
            value: filters.sort, title: "Index (sort) items on this transaction", closeable: true, height: 300, ref: refs.current[index], route: route, close: () => { }, callback: (e) => {
                if (e) {
                    setFilters({ ...filters, "sort": e });
                }
            }, offset: [0, 10],
            options: [
                { value: "id", label: "Default" },
                { value: "title", label: "Title (sort by title)" },
                { value: "isbn", label: "ISBN (sort by ISBN)" },
                { value: "cust_po", label: "Customer PO (sort by PO)" },
                { value: "quantity", label: "Qty (sort by qty, largest to smallest)" },
                { value: "date_added", label: "Date added" },
            ]
        })
    }


    const pos_items_nav = [
        { key: KBD.ESCAPE, action: () => toggleView() },
        { key: KBD.ARROW_DOWN, action: () => nextItem() },
        { key: KBD.ARROW_UP, action: () => prevItem() },
        { key: KBD.V, text: "View", icon: <ViewIconInv />, action: () => toggleView(), },
        { key: KBD.N, text: "New", icon: <NewIcon />, action: showNewRow, },
        { key: KBD.E, text: "Edit", icon: <EditIconInv />, action: () => switchToTransaction(), },
        { key: KBD.ALT_E, text: "@Edit", icon: <EditIconInv />, action: () => props.editTitle(() => { alert("callback"); }), },
    ];

    useEffect(() => {
        if (state.edit) { return; }

        const cleanup = listen(
            controller,
            ROUTES.POS.ITEMS,
            pos_items_nav,
            false,
            [KBD.ARROW_DOWN, KBD.ARROW_UP, KBD.ESCAPE, KBD.PAGE_DOWN]
        );

        return cleanup;
    }, [selected, data, state.edit]);


    const pos_edit_nav = [
        {
            key: KBD.ESCAPE,
            action: () => {
                cancelEdit(refs?.current?.[index], ROUTES.POS.EDIT);
            },
        },
        ...(header?.customer_ship_to
            ? [{
                text: "B/O",
                key: KBD.B,
                icon: <SettingsIcon />,
                action: () => updateItemStatus(),
            }]
            : []),
        { text: "Copy", icon: <CopyIconInv />, disabled: true },
        {
            key: KBD.V,
            text: "View",
            icon: <ViewIconInv />,
            action: () => {
                setState(s => ({ ...s, show_pos_card: !s.show_pos_card }));
            },
        },
        { key: KBD.ENTER, action: () => nextItem() },
        { key: KBD.N, text: "New", icon: <NewIcon />, action: showNewRow },
        { key: KBD.I, text: "Index", icon: <IndexIcon />, action: () => showSort() },
        { key: KBD.D, text: "Delete", icon: <DeleteIcon />, action: removeItem },
        { key: KBD.E, text: "Edit", icon: <EditIconInv />, action: editSelectedItemRow },
        {
            key: KBD.ALT_E,
            text: "@Edit",
            icon: <EditIconInv />,
            action: () => props.editTitle(),
        },
        { text: "Gift Receipt", icon: <GiftIcon />, disabled: true },
    ];

    const pos_row_edit_nav = [
        {
            key: KBD.ESCAPE,
            action: () => {
                cancelRowEdit();
            }
        },
        {
            key: KBD.PAGE_DOWN,
            action: () => {
                saveEditedRow();
            }
        },
        {
            key: KBD.ARROW_DOWN,
            action: () => {
                next();
            }
        },
        {
            key: KBD.ARROW_UP,
            action: () => {
                if (index === "cust_po") {
                    cancelRowEdit();
                } else {
                    prev();
                }
            }
        },
    ];





    return (
        <div style={{ display: "flex", flexDirection: "column", flex: "1 1 0", minHeight: 0 }}>
            <div onClick={() => {
                if (state?.edit && window.bm_state.value === ROUTES.POS.CUSTOMER) {
                    switchToTransaction();
                }
            }} style={{ padding: 0, display: "flex", flexDirection: "column", flex: "1 1 0", minHeight: 0, }}>





                <Label style={{ "textAlign": "left" }}>&nbsp;Transaction Items:</Label>

                <div className="shim" />
                <div className="bm-table-row">

                    {/* TABLE */}
                    {/* {!(state.edit || state.adding) && ( */}
                    <div className="bm-table-column">
                        <VirtualTable
                            rounded
                            className={(state.view !== "items") ? "desaturate" : ""}
                            row_height={26}
                            controller={controller}
                            onRowDoubleClick={(e) => {

                                if (e?.__new) {
                                    update("primary_code", "9780993888090")
                                } else {
                                    kbdEvent(KBD.E);
                                }

                            }}
                            onRowClick={(item) => {
                                if (state.editing) {
                                    return;
                                }
                                setAlign("auto");
                                setSelected(item);
                            }}
                            next={nextItem}
                            prev={prevItem}
                            align={align}
                            row_key={"pos_id"}
                            current={(state.adding) ? {} : (state.edit) ? selected : {}}
                            data={tableData}
                            // height={210}
                            onLoadMore={(_start, _end, _prepend) => {
                                if (_prepend) {
                                    if (data?.length > 0) {
                                        fetchPrev();
                                    }
                                } else {
                                    if (data?.length > 0) {
                                        fetchNext();
                                    }
                                }
                            }}
                            columns={columns}
                            width={0}
                            loading={loading}
                            // offset={461}
                            fullHeight
                            route={route}
                            scrollbar={true}
                            scrollindicator={true}
                            infinite={true}
                        />
                    </div>
                    {/* )} */}

                    {/* POS CARD */}
                    <Card
                        header={<Label style={{ textAlign: "left" }}>POS Transaction Log</Label>}
                        style={{ width: "282px" }}
                        secondary
                    >
                        <Label>POS Transaction Log</Label>
                    </Card>

                </div>



            </div>

            {(state.view === "items" && (state.adding || state.edit)) && <>
                <div className="shim" /><div className="shim" />


                {((state.adding || state.editing) && <div>
                    <Status><InfoIcon />{statuses?.[index] ?? ""}</Status>
                    <div className="shim" /><div className="shim" />
                </div>)}
                {(state.edit &&
                    <div style={{ flex: "0 0 auto" }}>
                        <Space style={{ "padding": "0px 0px" }}>
                            <IconNav nav={(state.adding) ? pos_new_nav : pos_edit_nav} />
                        </Space>
                    </div>
                )}

            </>}

        </div>
    )
}